import React from "react";
import ProductPricingsGenericSkeleton from "./ProductPricingsGenericSkeleton";

function ProductPricingsDetailSkeleton() {
  return (
    <>
      <ProductPricingsGenericSkeleton />
    </>
  );
}

export default ProductPricingsDetailSkeleton;
